module.exports = __webpack_public_path__ + "static/media/tbtc.e438dbd0.svg";